module.exports = __webpack_public_path__ + "static/img/6areaA_9.05164a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/6areaA_9.png
// module id = 1042
// module chunks = 1